import { NgModule } from '@angular/core';

import { EffectsModule, provideEffects } from '@ngrx/effects';
import { provideState, StoreModule } from '@ngrx/store';

import {
  deleteTellentAssistantThread,
  loadTellentAssistantThreads,
  updateTellentAssistantThreadPin,
} from './tellent-assistant-threads.effects';
import {
  TellentAssistantThreadsNamespace,
  TellentAssistantThreadsReducer,
} from './tellent-assistant-threads.state';

const effects = {
  loadTellentAssistantThreads,
  deleteTellentAssistantThread,
  updateTellentAssistantThreadPin,
};

export const provideTellentAssistantThreadsEffects = provideEffects(effects);
export const provideTellentAssistantThreadsState = provideState(
  TellentAssistantThreadsNamespace,
  TellentAssistantThreadsReducer,
);

export const provideTellentAssistantThreadsNgrx = [
  provideTellentAssistantThreadsEffects,
  provideTellentAssistantThreadsState,
];

@NgModule({
  imports: [
    StoreModule.forFeature(TellentAssistantThreadsNamespace, TellentAssistantThreadsReducer),
    EffectsModule.forFeature(effects),
  ],
})
export class TellentAssistantThreadsStoreModule {}
